<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<h2 id="AddPeerUserDialog" appLifecycleTracker trackerName="add-peer-user-dialog" mat-dialog-title>{{fTitle}}</h2>

<mat-dialog-content>
    <form id="registerForm" [formGroup]="registerForm">
        <div>
            <mat-form-field appearance="outline">
                <input id="registerFormFname" matInput type="text" formControlName="fname" placeholder="{{fFName}}" maxlength="255" />
                <mat-error *ngIf="registerForm.controls['fname'].errors?.required">{{'ADU_FIRST_REQ' | translate}}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <input id="registerFormLname" matInput type="text" formControlName="lname" placeholder="{{fLName}}" maxlength="255" />
                <mat-error *ngIf="registerForm.controls['lname'].errors?.required">{{'ADU_LAST_REQ' | translate}}</mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="outline">
                <input id="registerFormEmail" matInput type="text" formControlName="email" placeholder="{{fEMail}}" (blur)="onEmailBlur()" #emailInput />
                <mat-error *ngIf="registerForm.controls['email'].errors?.required">{{'EMAIL_REQ' | translate}}</mat-error>
                <mat-error *ngIf="registerForm.controls['email'].errors?.exists">{{fEMailExists}}</mat-error>
                <mat-error *ngIf="registerForm.controls['email'].errors?.pattern">{{fEMailInvalid}}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <input id="registerFormTitle" matInput type="text" formControlName="title" placeholder="{{fJob}}" maxlength="255" />
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="outline">
                <input id="registerFormDepartment" matInput type="text" formControlName="department" placeholder="{{fDepartment}}" maxlength="255" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <input id="registerFormLocation" matInput type="text" formControlName="location" placeholder="{{fLocation}}" maxlength="255" />
            </mat-form-field>
        </div>
        <div class="options-container">
            <div class="admin-radio">
                <label for="admin-radio" id="admin-radio-label">{{fRole}}</label>
                <mat-radio-group formControlName="role" id="admin-radio" aria-labelledby="admin-radio-label" color="primary">
                    <div style="margin-bottom: 5px;">
                        <mat-radio-button id="adminRadio" value="{{UserRole.ADMIN}}" color="primary">{{'APU_ADMIN' | translate}}</mat-radio-button>
                    </div>
                    <div>
                        <mat-radio-button id="userRadio"  value="{{UserRole.USER}}" color="primary">{{'APU_USER' | translate}}</mat-radio-button>
                    </div>
                    <div>
                        <mat-radio-button id="helpdeskRadio"  value="{{UserRole.HELP_DESK}}" color="primary">{{'APU_HELPDESK' | translate}}</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
            <div>
                <div class="key-gen">
                    <div class="key-gen-checkbox">
                        <mat-checkbox id = "generateKeysCheckbox" formControlName="generateKeys" (change)="changePasswordEnabled($event)">{{fGenerateKeys}}</mat-checkbox>
                    </div>
                    <div>
                        <mat-form-field class="key-pass" appearance="outline">
                            <input matInput type="text" formControlName="keyPassword" placeholder="{{fNewPass}}">
                        </mat-form-field>
                    </div>
                </div>
                <div class="key-gen">
                    <div>
                        <mat-checkbox id = "sendEmailCheckbox" class="send-email-checkbox" formControlName="sendEmail">{{fInvite}}</mat-checkbox>
                    </div>
                    <div>
                        <app-language-selector
                                label=""
                                [disabled]="doNotSendEmail"
                                [selectedLanguage]="selectedLanguage"
                                (valueChange)="onLanguageChanged($event)">
                        </app-language-selector>
                    </div>
                </div>

                <div *ngIf="data.showSecurityApproverCheckbox" class="security-approver-wrapper">
                    <div>
                        <mat-checkbox id="securityApproverCheckbox" class="security-approver-checkbox" formControlName="security_approver" (change)="approverChanged()">{{'SECURITY_REQUEST_APPROVER' | translate}}</mat-checkbox>
                    </div>
                    <div>
                        <mat-checkbox class="security-approver-checkbox" formControlName="notifyApprovers">{{'NOTIFY_APPROVERS' | translate}}</mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>

<div mat-dialog-actions class="dialog-button-group">
    <button id="AddOrganizationDialogCancel" mat-raised-button (click)="onCancelClick()" type="button">{{fCancel}}</button>
    <button id="AddOrganizationDialogSave" mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!registerForm.valid || checkingEmailExists" type="button">{{fSave}}</button>
    <button id="AddOrganizationDialogSaveAndAddMore" mat-raised-button color="primary" (click)="onSubmitAndAddMore()" [disabled]="!registerForm.valid" type="button">{{fSave}} &amp; {{fNew}}</button>
</div>
